import { HierarchyContextProps, IHierarchyActionAddSingleReplacement } from "../interface";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Adds a single replacement to the current hierarchy.
 *
 * @param state - The current hierarchy context state.
 * @param action - The add-single-replacement action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_addSingleReplacement = (
  state: HierarchyContextProps,
  action: IHierarchyActionAddSingleReplacement,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  if (state.hierarchy.singles.some((single) => single.airid === action.single.airid)) {
    return state;
  }

  return hcr_updateChangedFlag(
    {
      ...state,
      hierarchy: {
        ...state.hierarchy,
        singles: [...state.hierarchy.singles, action.single],
      },
    },
    action,
  );
};
